import {
	applyVlanPoolProfileFilter,
	focusVlanPoolProfile,
	openVlanPoolProfileSection,
} from './adapter';
import {
	openVlanPoolProfileCreateModal,
	openVlanPoolProfileDeleteModal,
	openVlanPoolProfileEditModal,
} from './modal';
import {resolveVlanPools} from './resolver';

/**
 * VLAN Pool profiles.
 *
 * VLAN Pool profiles are one of the twelve Global Profiles
 * accordions on the Templates page.
 *
 * Declares no fields: the Add and Edit forms are not mapped, so the agent
 * finds a profile and opens the form rather than filling it in. Delete
 * opens the confirmation and stops - the person presses the button.
 */
const vlanPoolingPlugin = {
	id: 'vlan_pooling',
	version: 1,
	commandVersion: 1,
	resource: 'vlan_pooling',
	operations: ['options', 'list', 'search', 'create', 'edit', 'delete'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['profile.dashboard'],
	},
	sections: {
		'profile.vlan_pools': openVlanPoolProfileSection,
	},
	resolvers: {
		vlan_pool: resolveVlanPools,
	},
	filters: {
		vlan_pool: (command) => applyVlanPoolProfileFilter(command.params?.query),
	},
	focusHandlers: {
		vlan_pool: (command) => focusVlanPoolProfile(command.params?.entity_id),
	},
	modals: {
		'vlan_pooling.create': openVlanPoolProfileCreateModal,
		'vlan_pooling.edit': openVlanPoolProfileEditModal,
		'vlan_pooling.delete': openVlanPoolProfileDeleteModal,
	},
};

export default vlanPoolingPlugin;
